import { isNilOrEmpty } from 'utils'

export const resolveContactName = (contact, resolveToEmail = false) => {
  if (!isNilOrEmpty(contact)) {
    if (contact.name) {
      return contact.name
    }

    const hasAttributes = !isNilOrEmpty(contact.attributes)

    if (hasAttributes && !isNilOrEmpty(contact.attributes.name)) {
      return contact.attributes.name
    }

    if (hasAttributes &&
      (!isNilOrEmpty(contact.attributes.first_name) || !isNilOrEmpty(contact.attributes.last_name))) {
      return `${contact.attributes.first_name || ''} ${contact.attributes.last_name || ''}`.trim()
    }

    if (resolveToEmail && contact.email) {
      return contact.email
    }

    if (contact.alias) {
      return contact.alias
    }

    if (hasAttributes && !isNilOrEmpty(contact.attributes.alias)) {
      return contact.attributes.alias
    }
  }

  return 'Site Visitor'
}